import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const CatalogueRouteMiddleware = ({ fallbackPath }) => {
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  if (
    permissions.catalogue_master_create === true ||
    permissions.catalogue_master_edit === true ||
    permissions.catalogue_master_view === true
  ) {
    return <Outlet />;
  } else {
    return <Navigate to={fallbackPath} />;
  }
};

export default CatalogueRouteMiddleware;
